export enum FileSizeType {
    BYTE = 'BYTE',
    KB = "KB",
    MB = "MB",
    GB = "GB",
    TB = "TB",
    PB = "PB",
}

export enum FileSizeValueType {
    BYTE = 1,
    KB = 1000,
    MB = 1000000,
    GB = 1000000000,
    TB = 1000000000000,
    PB = 1000000000000000,
}

export enum FileSizeTypeName {
    BYTE = 'Byte',
    KB = "Kilobyte",
    MB = "Megabyte",
    GB = "Gigabyte",
    TB = "Terabyte",
    PB = "Petabyte",
}